module.exports = __webpack_public_path__ + "img/treebu_logo-white.9a3b5e63.png";